import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginScreen } from '~/components/auth/LoginScreen';

export const Route = createFileRoute('/login')({
  // Demo build: a session always exists, so this always bounces to `/`, which
  // itself forwards to /ninety. That is one hop, not a loop — /ninety never
  // redirects back here. The screen is kept so the route stays valid.
  beforeLoad: ({ context }) => {
    if (context.auth?.session) throw redirect({ to: '/' });
  },
  component: LoginScreen,
});
